module.exports = __webpack_public_path__ + "img/example-digital-dashboard-kpi.b0a2afa5.webp";